<lib-generic-list
  #genericList
  [dataProvider]="dataProvider"
  [totalCount]="totalCount"
  [columnsProvider]="columnsProvider"
  [actionsProvider]="actionsProvider"
  [noResultsMessageDisplayKey]="noResultsMessageDisplayKey"
  [itemsPerPageDisplayKey]="itemsPerPageDisplayKey"
  [entriesDisplayKey]="
    totalCount
      ? (genericList.page - 1) * genericList.pageSize +
        1 +
        ' - ' +
        (genericList.page * genericList.pageSize > genericList.totalCount
          ? totalCount
          : genericList.page * genericList.pageSize) +
        ' ' +
        ('of' | translate) +
        ' ' +
        totalCount +
        ' ' +
        ('results' | translate)
      : ''
  "
  [serverPaging]="showPagination"
  [showPagination]="showPagination"
  [defaultPagination]="true"
  [showJumpToPage]="false"
  [tableStriped]="false"
  [actionsColumnLeft]="false"
  [page]="page"
  [pageSize]="pageSize"
  [rowHeight]="'40px'"
  (stateChanged)="stateChanged.emit($event)"
  (actionClick)="actionClick.emit($event)"
>
</lib-generic-list>
